module.exports = __webpack_public_path__ + "static/california-condors-607bdf88d83f0b4f6d9af0deb75c4b6a.jpg";